module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand2_jp.3be52b7dcc56c45bdd09b8cb3fcdfb5b.png";